import React from 'react';
import PropTypes from 'prop-types';

const SelectFieldHOC = (Component) => {
  class hoc extends React.Component {
    constructor (props) {
      super(props);

      this.isValid = this.isValid.bind(this);
    }

    isValid () {
      return this.props.isValid();
    }

    render () {
      return <Component {...this.props} />;
    }
  }

  hoc.propTypes = {
    dispatch: PropTypes.func
  };

  return hoc;
};

export default SelectFieldHOC;
